/**
 * Lightweight validation helpers shared across the funnel + admin.
 *
 * Centralizing the email regex avoids subtle drift across components
 * (Step13 checkout, account login, waitlist captures...) — every caller
 * gets the same rule and any future tweak (e.g. tightening TLD checks)
 * lives in one place.
 */

/**
 * Validates an email address using a permissive but practical regex.
 *
 * The pattern matches: `local@domain.tld` where neither part contains
 * whitespace nor an extra `@`. Trims surrounding whitespace before
 * testing so leading/trailing spaces don't reject otherwise valid input.
 */
export function validateEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}
